<template>
	<div class="c-quoteblock__wrapper">
		<div class="c-quoteblock__inner">
			<div class="c-quoteblock__inner--icon" v-if="displayIcon">
				<v-icon :name="icon" size="lg" />
			</div>
			<div class="c-quoteblock__inner--quote">
				<div class="c-quoteblock__quote">{{ quote }}</div>
				<div class="c-quoteblock__quoteby">{{ quoteBy }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";
export default {
	name: "VQuoteBlock",
	components: {
		VIcon
	},
	props: {
		quote: {
			type: String,
			default: ''
		},
		quoteBy: {
			type: String,
			default: ''
		},
		displayIcon: {
			type: Boolean,
			default: ''
		},
		icon: {
			type: String,
			default: 'quote'
		}
	}
};
</script>
